import config from "../config.json";
import { useMap } from 'react-leaflet'
import L, { tileLayer } from 'leaflet';
import 'leaflet-wms-header';
//import http from "../Services/httpService";
import React, { useContext, useEffect, useState, useMemo } from "react";
import './AddTileLayer.css'

export default function AddTileLayer() {
  const map = useMap();
  const [layerControl, setLayerControl] = useState(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    //if (map.dd)
    //  return;
    //map.dd = "1";
    if (!map || map._layerControlInitialized)
      return;
    map._layerControlInitialized = true;

    const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© noron',
      subdomains: ['a', 'b', 'c']
    });
    ///osm.addTo(map);///
    //--------------------------------------
    const mapBox = tileLayer(
      `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=${config.mapBoxKey}`,
      {
        attribution: 'OpenStreetMap',
        maxZoom: 18,
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
        //accessToken:
      });
    //------------------------------
    const google1 = L.tileLayer("https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
      maxZoom: 19,
      attribution: '© noron',
      subdomains: ['0', '1', '2', '3']
    });
    const google2 = L.tileLayer("https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}", {
      maxZoom: 19,
      attribution: '© noron',
      subdomains: ['0', '1', '2', '3']
    });
    const google3 = L.tileLayer("https://mt{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}", {
      maxZoom: 19,
      attribution: '© noron',
      subdomains: ['0', '1', '2', '3']
    });

    //const jwt = "Bearer " + http.getLocalJwt();
    const localOsm = L.tileLayer(`${config.mapUrl}/api/tiles/cache/osm/{z}/{x}/{y}.png`,
      { maxZoom: 19, attribution: '© noron', });
    localOsm.addTo(map);///
    //--------------
    const localMapir1 = L.tileLayer(`${config.mapUrl}/api/tiles/cache/mapir1/{z}/{x}/{y}.png`,
      { maxZoom: 19, attribution: '© noron', });
    //--------------------------------- 
    const localMapbox = L.tileLayer(`${config.mapUrl}/api/tiles/cache/mapbox/{z}/{x}/{y}.png`,
      { maxZoom: 19, attribution: '© noron', });
    //------------------------------------------

    /*
        const customTileLayer = L.TileLayer.extend({
          initialize: function (url, options) {
            this._headers = options.headers || {};
            L.TileLayer.prototype.initialize.call(this, url, options);
          },
          createTile: function (coords, done) {
            const tile = document.createElement('img');
            const url = this.getTileUrl(coords);
    
            fetch(url, {
              headers: this._headers
            })
              .then(response => response.blob())
              .then(blob => {
                tile.src = URL.createObjectURL(blob);
                done(null, tile);
              })
              .catch(err => done(err, tile));
            return tile;
          }
        });
    
        // استفاده:
        const localOsm = new customTileLayer(`${config.apiUrl}/api/tiles/cache/osm/{z}/{x}/{y}.png`, {
          headers: {
            Authorization: jwt
          }
        }).addTo(map);
    */
    // *-----------------------------------------------------
    /*
        const mapIr = L.TileLayer.wmsHeader(
          "https://map.ir/shiveh",
          {
            attribution: '© map.ir © openstreetmap',
            layers: "Shiveh:Shiveh",
            format: "image/png",
          },
          [
            {
              header: "x-api-key",
              value: `${config.mapApiKey}`
            }
          ]
        );
        */
    //mapIr.addTo(map);
    //--------------------------------    


    const baseMaps = {
      "نقشه منبع 1": osm,
      // "نقشه منبع 2": mapIr,
      "نقشه ماهواره ای منبع 2": mapBox,
      "نقشه گوگل عادی": google1,
      "نقشه گوگل ماهواره ای": google2,
      "نقشه گوگل ماهواره ای2": google3,

      "نقشه 1": localOsm,
      "نقشه 2": localMapir1,
      "نقشه ماهواره ای 1": localMapbox,

    };

    /*
        const littleton = L.marker([39.61, -105.02]).bindPopup('This is Littleton, CO.'),
          denver = L.marker([39.74, -104.99]).bindPopup('This is Denver, CO.'),
          aurora = L.marker([39.73, -104.8]).bindPopup('This is Aurora, CO.'),
          golden = L.marker([39.77, -105.23]).bindPopup('This is Golden, CO.');
          
        const cities = L.layerGroup([littleton, denver, aurora, golden]);
        const overlayMaps = {
          "موتورسیکلت": cities
        };
        const layerControl = L.control.layers(baseMaps, overlayMaps,{position: 'topleft'});//.addTo(map);
        */
    const control = L.control.layers(baseMaps, null, { position: 'topleft', collapsed: false });//.addTo(map);
    //const crownHill = L.marker([39.75, -105.09]).bindPopup('This is Crown Hill Park.'),
    //  rubyHill = L.marker([39.68, -105.00]).bindPopup('This is Ruby Hill Park.');
    //const parks = L.layerGroup([crownHill, rubyHill]);

    ///layerControl.addBaseLayer(osm, "Satellite");
    //layerControl.addOverlay(parks, "خودروهای عمومی");
    //layerControl.addTo(map);
    setLayerControl(control);

  }, [map]);
  useEffect(() => {
    if (!layerControl) return;
    if (visible) {
      layerControl.addTo(map);
    } else {
      layerControl.remove();
    }
  }, [visible, layerControl, map]);

  return (
    <>
      <div className="custom-layer-toggle" onClick={() => setVisible(!visible)}>
        🗺️
      </div>
      {/*
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name="عادی">
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="ماهواره">
                <TileLayer
                  url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token==${config.mapBoxKey}`}
                />
              </LayersControl.BaseLayer>


              <LayersControl.Overlay name="Marker with popup">
                <Marker >
                  <Popup position={[39.74, -104.99]}>
                    A pretty CSS3 popup. <br /> Easily customizable.
                  </Popup>
                </Marker>
               
              </LayersControl.Overlay>             
            </LayersControl>
            */}



    </>
  );
}


